<footer class="p-5 footer-wrap" id="footer-wrap">
  <div class="container">
    <div class="row">
      <div class="col-md-8">
        <p class="copyRight mb-0 mt-1">
          @2022 - Junta de Castilla y Leon - Consejeria de Sanidad
        </p>
      </div>

      <div class="col-md-4 text-right" *ngIf="faq.socials">
        <div class="socials">
          <a
            *ngIf="faq.socials.facebook"
            [href]="faq.socials.facebook"
            target="_blank"
            class="icons ml-2 mr-2"
            ><i class="fab fa-facebook-f fa-2x"></i
          ></a>
          <a
            *ngIf="faq.socials.twitter"
            [href]="faq.socials.twitter"
            target="_blank"
            class="icons ml-2 mr-2"
            ><i class="fab fa-twitter fa-2x"></i
          ></a>
          <a
            *ngIf="faq.socials.instagram"
            [href]="faq.socials.instagram"
            target="_blank"
            class="icons ml-2 mr-2"
            ><i class="fab fa-instagram fa-2x"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
  <!-- footer-wrap close -->
</footer>
<!-- footer close -->

<!-- TAC Modal -->
<div
  class="modal fade"
  id="modal-tac"
  tabindex="-1"
  role="dialog"
  aria-labelledby="Términos y Condiciones"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" style="border-radius: 8px">
      <div class="modal-header">
        <h4 class="mb-0">Términos y Condiciones</h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{ company.term_and_conditions }}
      </div>
    </div>
  </div>
</div>
